import React from "react";
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Typography from "@mui/material/Typography";

export default function MasterEntryTable({ categoryId, entries, startIndex = 0, onEdit, onLogicalDelete, onRowClick }) {
  const showCode = categoryId !== "categories" && categoryId !== "master_items";

  return (
    <TableContainer className={"box-shadow"} component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="master table">
        <TableHead>
          <TableRow>
            <TableCell align="left" sx={{ color: "#B3B3B3", width: 20 }}>
              Sl.No
            </TableCell>
            {showCode && (
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Code
              </TableCell>
            )}
            <TableCell align="left" sx={{ color: "#B3B3B3" }}>
              Name
            </TableCell>
            <TableCell align="left" sx={{ color: "#B3B3B3" }}>
              Description
            </TableCell>
            <TableCell align="left" sx={{ color: "#B3B3B3" }}>
              Status
            </TableCell>
            <TableCell align="center" sx={{ color: "#B3B3B3" }}>
              Action
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {entries?.length > 0 ? (
            entries.map((e, idx) => (
              <TableRow hover key={e.id} onClick={() => onRowClick?.(e)} sx={{ cursor: onRowClick ? "pointer" : "default" }}>
                <TableCell>{startIndex + idx + 1}</TableCell>
                {showCode && <TableCell sx={{ color: "#3D3D3D" }}>{e?.code || "-"}</TableCell>}
                <TableCell sx={{ color: "#3D3D3D" }}>{e?.name || "-"}</TableCell>
                <TableCell sx={{ color: "#3D3D3D" }}>{e?.description || "-"}</TableCell>
                <TableCell sx={{ color: "#3D3D3D" }} className={"text-capitalize"}>
                  {e?.status || "active"}
                </TableCell>
                <TableCell align="center">
                  <Tooltip title={"Edit"}>
                    <IconButton
                      onClick={(ev) => {
                        ev.stopPropagation();
                        onEdit?.(e);
                      }}
                      sx={{ bgcolor: "#fff", boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;" }}
                    >
                      <DriveFileRenameOutlineIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={"Delete"}>
                    <IconButton
                      onClick={(ev) => {
                        ev.stopPropagation();
                        onLogicalDelete?.(e.id);
                      }}
                    >
                      <DeleteForeverIcon sx={{ color: "red" }} />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={7} style={{ textAlign: "center" }}>
                <Typography style={{ color: "red" }}>No master entries</Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
